module.exports = __webpack_public_path__ + "static/media/EmptyIssuesNew.859b9f92.png";